import { gql } from '@apollo/client';

import client from '../../../core/services/graphql';

export const getUser = async (id) => {
  const query = gql`
    query User($user_id: ID!) {
      user(userId: $user_id) {
        id
        profile {
          id
          firstName
          lastName
          gender
          raceEthnicHeritage
          birthdate
          annualHouseholdIncome
          country
          state
        }
      }
    }
  `;

  const { data } = await client.getClient().query({
    query,
    variables: {
      user_id: id,
    },
    fetchPolicy: 'network-only',
  });

  return data;
};

export const updateUser = async (id, attributes) => {
  const query = gql`
    mutation UpdateUserPersonalData($id: ID!, $attributes: ProfileAttributes!) {
      updateUserSignupSurvey(id: $id,  attributes: $attributes) {
        profile {
          jobInfo
          state
          country
          email
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation: query,
    variables: { id, attributes },
  });

  return data;
};
